import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IConfigProductHierarchyResponseModel } from '../../../features/maps/interfaces/config-product-hierarchy-response.model';
import { IRangeResponse } from '../../../features/maps/interfaces/range-response.model';

@Component({
    selector: 'lynkd-pattern-report-filters',
    templateUrl: './report-filters.component.html',
    styleUrls: ['./report-filters.component.scss']
})
export class ReportFiltersComponent {
    @Input() public availableBrandValues: Array<IConfigProductHierarchyResponseModel> = [];
    @Input() public availableDepartmentValues: Array<IConfigProductHierarchyResponseModel> = [];
    @Input() public availableRanges: Array<IRangeResponse> = [];
    @Input() public selectedBrandId: string;
    @Input() public selectedDepartmentId: string;
    @Input() public selectedRangeId: string;

    @Output() public readonly brandChanged: EventEmitter<string> = new EventEmitter<string>();
    @Output() public readonly departmentChanged: EventEmitter<string> = new EventEmitter<string>();
    @Output() public readonly seasonChanged: EventEmitter<string> = new EventEmitter<string>();

    public getShortId(id: string): string {
        if (!id) {
            return id;
        }
        const parts: Array<string> = id.split('|');
        return parts.length > 1 ? parts[1] : id;
    }

    public onBrandChange(): void {
        this.brandChanged.emit(this.selectedBrandId);
    }

    public onDepartmentChange(): void {
        this.departmentChanged.emit(this.selectedDepartmentId);
    }

    public onSeasonChange(): void {
        this.seasonChanged.emit(this.selectedRangeId);
    }
}
